// ログイン情報などのストア

import { reactive } from "vue";
import aixos from 'axios';
import router from "../router";

export default function LoginStates() {
	// 状態
	const login = reactive ({
		// ユーザーID
		id: "",
		// 名前
		user_name: "",
		// 性別
		sex: "",
		// ログインID
		loginid: "",
		// パスワード（ログイン用）
		password: "",
		// 現在のパスワード（パスワード変更用）
		oldPass: "",
		// 新しいパスワード
		newPass: "",
		// メールアドレス
		email: "",
		// 新しいメールアドレス
		newEmail: "",
		// 職業
		// job: "",
		// アンケート
		anketo: false,	//ありなし
		iraidate: "",	//依頼日
	});

	// ログインする
	const isLogin = async () => {
		try {
			const res = await aixos.post('/api/login/common', {
				username: login.loginid,
				password: login.password,
			}, { 
				withCredentials: true
			})
			// console.log(res);
			// console.log(res.data)
			login.id = res.data.id;
			login.sex = res.data.sex_code;
			login.email = res.data.mail;
			login.user_name = res.data.user_name;
			// ログイン情報（性別）をセッションストレージに保存
			sessionStorage.setItem("LOGIN", res.data.sex_code);
		} catch (e) {
			console.log('error内容');
			console.log(e.response.status);
			return e.response.status;
		}

		// // ログイン成功時
		// if(res.data.sex_code) {
		// 	console.log('success!')
		// 	// トップページへ遷移
		// 	router.push({ path: '/'});
		// }

		anketo();
	};

	// ログインする
	const autoLogin = async () => {
		const res = await aixos.post('/api/login/common', {
			username: login.loginid,
			password: login.password,
		}, { 
			withCredentials: true
		})
		console.log(res);
		console.log(res.data)
		login.id = res.data.id;
		login.sex = res.data.sex_code;
		login.email = res.data.mail;
		login.user_name = res.data.user_name;

		// ログイン成功時
		if(res.data.sex_code) {
			console.log('success!')
		}
		// ログイン情報（性別）をセッションストレージに保存
		sessionStorage.setItem("LOGIN", res.data.sex_code);

		anketo();
	};

	// アンケート通知確認
	const anketo = async () => {
		const res = await aixos.get('/api/anketo/exists')
		login.anketo = res.data.jyotai;
		login.iraidate = res.data.irai_date;
	}

	// ログアウト処理
	const isLogout = async () => {
		// セッションストレージより削除
		sessionStorage.removeItem("LOGIN");
		login.sex = "";
		login.loginid = "";
		login.password = "";
		router.push({ path: '/'});
	};

	// 
	const localLog = async () => {
		window.addEventListener('beforeunload', function(){
			// ローカルストレージ保存
			// localStorage.setItem('username', login.loginid)
			// localStorage.setItem('password', login.password)
			if(login.sex){
				sessionStorage.setItem('nickname',login.password);
				sessionStorage.setItem('username',login.user_name);
				sessionStorage.setItem('email',login.email);
				sessionStorage.setItem('sexcode',login.sex);
				sessionStorage.setItem('loginid',login.loginid);
				sessionStorage.setItem('id',login.id);
			}
		})
		window.addEventListener('load', function(){
			if(sessionStorage.getItem('id')){
				login.loginid = sessionStorage.getItem('loginid');
				login.sex = Number(sessionStorage.getItem('sexcode'));
				login.id = Number(sessionStorage.getItem('id'));
				login.email = sessionStorage.getItem('email');
				login.user_name = sessionStorage.getItem('username');
				login.password = sessionStorage.getItem('nickname');
				sessionStorage.removeItem('loginid');
				sessionStorage.removeItem('sexcode');
				sessionStorage.removeItem('id');
				sessionStorage.removeItem('email');
				sessionStorage.removeItem('username');
				sessionStorage.removeItem('nickname');
				if(login.sex > 0) {
					sessionStorage.setItem("LOGIN", login.sex);
				}
				// console.log('login')
				// console.log(login.sex)
				anketo();
			}
		})
	}
	localLog();

	return {
		login,
		isLogin,
		isLogout,
		autoLogin,
		localLog
	}
}